<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="epi"> </p>
<p class="EP"><span class="ePub-I">No human race is superior; no religious faith is inferior. All collective judgments are wrong. Only racists make them.</span></p>
<p class="EPC">—<span class="ePub-SC">ELIE WIESEL</span></p>
<p class="EP"><span class="ePub-I">A man’s reach should exceed his grasp, or what’s a heaven for?</span></p>
<p class="EPC">—<span class="ePub-SC">ROBERT BROWNING</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?7d18e778